import PropTypes from 'prop-types';
import React from 'react';
import Select from '../../../components/Select';
import { jsx as _jsx } from "react/jsx-runtime";

var ActivationQuestion = function ActivationQuestion(_ref) {
  var answer = _ref.answer,
      idx = _ref.idx,
      label = _ref.label,
      moduleClass = _ref.moduleClass,
      onAnswer = _ref.onAnswer,
      placeholder = _ref.placeholder,
      values = _ref.values;
  var response = answer.response === undefined ? '' : answer.response;
  /* eslint-disable jsx-a11y/label-has-for */

  return /*#__PURE__*/_jsx("div", {
    className: "".concat(moduleClass, "__question"),
    children: /*#__PURE__*/_jsx(Select, {
      buttonProps: {
        full: true,
        gray: true
      },
      hideLabel: false,
      label: label,
      name: label,
      onChange: function onChange(event) {
        onAnswer(event, idx);
      },
      options: values.map(function (option) {
        return {
          label: option,
          value: option
        };
      }),
      placeholder: placeholder,
      value: response
    })
  });
};

ActivationQuestion.displayName = 'ActivationQuestion';
ActivationQuestion.defaultProps = {
  answer: {},
  values: []
};
ActivationQuestion.propTypes = {
  answer: PropTypes.shape(),
  idx: PropTypes.number.isRequired,
  moduleClass: PropTypes.string.isRequired,
  onAnswer: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};
export default ActivationQuestion;